import { render, staticRenderFns } from "./MainFavourites.vue?vue&type=template&id=0c3340f7&"
import script from "./MainFavourites.vue?vue&type=script&lang=js&"
export * from "./MainFavourites.vue?vue&type=script&lang=js&"
import style0 from "./MainFavourites.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports